function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import { Flipped } from "react-flip-toolkit";
import styled from "styled-components";
import { connect as connectFormik } from "formik";
import { Row, SpacedCol } from "../../../grid";
import Input from "../../../input";
import { withContext } from "../../../wr-context";
import { TextComponent, EditorComponent, HTMLComponent, HeaderComponent, RadioComponent, DropdownInput, CheckboxComponent, DatepickerComponent, DocumentsComponent, FaqsComponent, BundlesComponent } from "./components";
import { utils } from "../../../../modules/product";
import propTypes from "prop-types";
function getRowComponents(row, context, overrides) {
    var ref, ref1, ref2;
    if ((row === null || row === void 0 ? void 0 : (ref = row.options) === null || ref === void 0 ? void 0 : ref.access) === "hidden") {
        return null;
    }
    if (!context.state.isLoggedIn && (row === null || row === void 0 ? void 0 : (ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.access) === "private") {
        return null;
    }
    if (row === null || row === void 0 ? void 0 : (ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.isInHeader) return null;
    switch(row.rowType){
        case "text":
        case "free-text":
            var ref3;
            if ((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.isEditor) {
                return [
                    (overrides === null || overrides === void 0 ? void 0 : overrides.editor) || (overrides === null || overrides === void 0 ? void 0 : overrides.text),
                    EditorComponent
                ];
            } else {
                return [
                    overrides === null || overrides === void 0 ? void 0 : overrides.text,
                    TextComponent
                ];
            }
        case "editor":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides.html,
                HTMLComponent
            ];
        case "style:header":
            return [
                (overrides === null || overrides === void 0 ? void 0 : overrides.header) || (overrides === null || overrides === void 0 ? void 0 : overrides["style:header"]),
                HeaderComponent
            ];
        case "radio":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides.radio,
                RadioComponent
            ];
        case "dropdown":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides.dropdown,
                DropdownInput
            ];
        case "checkbox":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides.checkbox,
                CheckboxComponent
            ];
        case "documents":
        case "component:documents":
            return [
                (overrides === null || overrides === void 0 ? void 0 : overrides.documents) || (overrides === null || overrides === void 0 ? void 0 : overrides["component:documents"]),
                DocumentsComponent
            ];
        case "datepicker":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides.datepicker,
                DatepickerComponent
            ];
        case "component:feedback":
            return [
                (overrides === null || overrides === void 0 ? void 0 : overrides.feedback) || (overrides === null || overrides === void 0 ? void 0 : overrides["component:feedback"]),
                null
            ];
        case "component:faqs":
            return [
                (overrides === null || overrides === void 0 ? void 0 : overrides.faqs) || (overrides === null || overrides === void 0 ? void 0 : overrides["component:faqs"]),
                FaqsComponent
            ];
        case "component:bundles":
            return [
                overrides === null || overrides === void 0 ? void 0 : overrides["component:bundles"],
                BundlesComponent
            ];
        default:
            if (overrides === null || overrides === void 0 ? void 0 : overrides[row.rowType]) return [
                overrides[row.rowType],
                null
            ];
            if (process.env.NODE_ENV !== "production") {
            // console.log('Unimplemented', row.rowType, row)
            }
            return null;
    }
}
var RowWrapper = styled.div(_templateObject());
var ProductRow = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ProductRow, Component);
    var _super = _createSuper(ProductRow);
    function ProductRow(props) {
        _classCallCheck(this, ProductRow);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isAnimating: true
        };
        _this.animationStopTimeout = undefined;
        _this.handleSkipTo = function(order, skipTo) {
            var formik = _this.props.formik;
            var newSkipRange = _objectSpread({}, formik.values.skipRange);
            if (skipTo) {
                newSkipRange[order] = utils.parseSkipTo(skipTo);
            } else {
                if (newSkipRange.hasOwnProperty(order)) {
                    delete newSkipRange[order];
                }
            }
            formik.setFieldValue("skipRange", newSkipRange);
        };
        _this.renderMultiplierField = function(props) {
            var ref, ref1;
            return ((ref = _this.props.overrides) === null || ref === void 0 ? void 0 : ref.multiplierField) ? (ref1 = _this.props.overrides) === null || ref1 === void 0 ? void 0 : ref1.multiplierField(props, _this.props, Input) : /*#__PURE__*/ React.createElement(Input, _extends({}, props));
        };
        _this.RowComponent = null;
        _this.DefaultRowComponent = null;
        var ref = _slicedToArray(getRowComponents(props.row, props.context, props.overrides) || [], 2), overrideComponent = ref[0], defaultComponent = ref[1];
        var RowComponent = overrideComponent || defaultComponent;
        if (RowComponent && RowComponent.shouldComponentUpdate) {
            _this.shouldComponentUpdate = function(nextProps) {
                return nextProps.formik.values.skipRange !== _this.props.formik.values.skipRange || RowComponent.shouldComponentUpdate(nextProps, _this.props);
            };
        }
        _this.RowComponent = RowComponent;
        _this.DefaultRowComponent = defaultComponent;
        return _this;
    }
    var _proto = ProductRow.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this = this;
        this.animationStopTimeout = setTimeout(function() {
            _this.setState({
                isAnimating: false
            });
        }, 400);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(Number(this.animationStopTimeout));
    };
    _proto.render = function render() {
        var _props = this.props, formik = _props.formik, context = _props.context, row = _props.row, rest = _objectWithoutProperties(_props, [
            "formik",
            "context",
            "row"
        ]);
        if (!this.RowComponent) {
            return null;
        }
        var isInSkipRange = utils.checkIsInSkipRange(formik.values.skipRange || {})(row.order);
        if (isInSkipRange) {
            return null;
        }
        return /*#__PURE__*/ React.createElement(Row, {
            "data-testid": "product-row__".concat(row.id)
        }, /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(Flipped, {
            flipId: row.id,
            translate: true,
            opacity: true
        }, /*#__PURE__*/ React.createElement(RowWrapper, {
            isAnimating: this.state.isAnimating
        }, /*#__PURE__*/ React.createElement(this.RowComponent, _extends({
            row: row,
            handleSkipTo: this.handleSkipTo,
            renderMultiplierField: this.renderMultiplierField,
            allowHelpText: context.constants.product.details.displayItemRowHint,
            defaultComponent: this.DefaultRowComponent
        }, rest))))));
    };
    return ProductRow;
}(Component);
ProductRow.propTypes = {
    row: propTypes.object.isRequired,
    overrides: propTypes.object,
    formik: propTypes.any,
    context: propTypes.any,
    product: propTypes.object.isRequired,
    hideLabel: propTypes.bool,
    disabled: propTypes.bool
};
ProductRow.defaultProps = {
    overrides: {},
    context: {},
    formik: null,
    hideLabel: false,
    disabled: false
};
export default connectFormik(withContext(ProductRow));
